import React from "react";
import PropTypes from "prop-types";
import { Button as AntdButton } from "antd";
import { cn } from "utils/cn";

const VARIANT_CLASSES = {
  primary:
    "bg-black text-white border-black text-base font-medium hover:bg-black hover:border-black hover:text-white focus:text-white focus:bg-black/80",
  outline:
    "bg-white text-black border-black text-base font-medium hover:bg-black/5 hover:text-black",
};

const SIZE_CLASSES = {
  small: "h-8",
  medium: "h-10",
  large: "h-[52px]",
};

export const AntButton = ({
  variant = "primary",
  size = "medium",
  className = "",
  children,
  htmlType = "button",
  ...rest
}) => {
  const baseClasses =
    "btn flex items-center justify-center px-5 rounded-2xl leading-none border shadow-none transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed min-w-[175px]";
  const variantClasses = VARIANT_CLASSES[variant] || VARIANT_CLASSES.primary;
  const sizeClasses = SIZE_CLASSES[size] || SIZE_CLASSES.medium;
  return (
    <AntdButton
      type="text"
      className={cn(baseClasses, variantClasses, sizeClasses, className)}
      htmlType={htmlType}
      {...rest}
    >
      {children}
    </AntdButton>
  );
};

AntButton.propTypes = {
  variant: PropTypes.oneOf(["primary", "outline"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  className: PropTypes.string,
  children: PropTypes.node,
  htmlType: PropTypes.string,
};    
